import styled from '@emotion/styled';
import { Grid } from '@mui/material';
import { useForm } from 'react-hook-form';
import { IJobBoard } from 'wisestep-api';
import { WsTypography, WsTypoVariants, Label } from 'wisestep-base';

import {
  useJobBoardAccessControl,
  PremiumJobBoardsAction,
} from '../../../../hooks/useJobBoardAccessControl';
import { DeleteIconButton } from '../../../crmSettings/components/StyledIconButtons';

type PropTypes = {
  selectedAccount: IJobBoard;
  callBackHandler: (data: IJobBoard) => void;
  jobBoardName?: string;
};
export const BoldLabel = styled(Label)(() => ({
  fontWeight: 'bold',
}));
const SharedUserList = ({ selectedAccount, callBackHandler, jobBoardName }: PropTypes) => {
  const methods = useForm();
  const { handleSubmit } = methods;

  const actionHandler = async (index: number, type: string) => {
    const handler = {
      ['onDelete']: () => {
        selectedAccount.jobBoardSharedUsers?.splice(index, 1);
      },
    };
    handler[type]();
    callBackHandler(selectedAccount);
  };
  const { access, owns } = useJobBoardAccessControl([
    PremiumJobBoardsAction.DELETE_PREMIUM_JOB_POSTING_ACCOUNTS,
  ]);
  const [deleteJobBoard] = access;
  return (
    <Grid container p={2}>
      <Grid item xs={4.5}>
        <BoldLabel>Shared Workspace User</BoldLabel>
      </Grid>
      <Grid item xs={4}>
        <BoldLabel>{`Max postings allowed ${
          jobBoardName == 'Dice' || jobBoardName == 'TechFetch' ? '' : '/month'
        }`}</BoldLabel>
      </Grid>
      {selectedAccount.jobBoardSharedUsers?.map((key, index) => (
        <Grid marginTop={2} item container xs={12} mb={2} key={index}>
          <Grid item xs={5} pr={2}>
            <WsTypography variant={WsTypoVariants.BODY1}>{key.email}</WsTypography>
          </Grid>
          <Grid item xs={4}>
            <WsTypography variant={WsTypoVariants.BODY1}>{key.maxPostingsPerMonth}</WsTypography>
          </Grid>
          {(deleteJobBoard || owns) && (
            <Grid item xs={1.5}>
              <DeleteIconButton onClick={handleSubmit(() => actionHandler(index, 'onDelete'))} />
            </Grid>
          )}
        </Grid>
      ))}
    </Grid>
  );
};
export default SharedUserList;
